module.exports = __webpack_public_path__ + "img/fenxiang.951d531d.jpg";